module.exports = __webpack_public_path__ + "static/media/nutrizones_testimonial_video.f2d17d8c.jpg";